import { render } from "./IdentityRegistration.vue?vue&type=template&id=3183313a&scoped=true"
import script from "./IdentityRegistration.vue?vue&type=script&lang=js"
export * from "./IdentityRegistration.vue?vue&type=script&lang=js"

import "./IdentityRegistration.vue?vue&type=style&index=0&id=3183313a&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/ADP_CashParis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3183313a"]])

export default __exports__